module.exports = __webpack_public_path__ + "img/close.9d78e318.svg";